export class Carrinho {
    idProduto: number = 0;
    dsProduto: string = '';
    valor: number = 0;
}

export class RetornoAssinar {
    idPedido: string = '';
    confirmacao: boolean = false;
    mensagem: string = '';
}
